import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { Enterprise } from '../models/business.model';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor() { }

  // Obtenir la position actuelle de l'utilisateur
  getCurrentPosition(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject('La géolocalisation n\'est pas supportée');
      }
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }

  // Calculer la distance entre deux points
  calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Rayon de la terre en km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const d = R * c; // Distance en km
    return Math.round(d * 10) / 10; // Arrondir à 1 décimale
  }

  // Convertir degrés en radians
  private deg2rad(deg: number): number {
    return deg * (Math.PI/180);
  }

  // Calculer la distance pour une entreprise
  calculateEnterpriseDistance(enterprise: Enterprise): Observable<number> {
    return from(this.getCurrentPosition()).pipe(
      map(position => {
        if (enterprise.latitude && enterprise.longitude) {
          return this.calculateDistance(
            position.coords.latitude,
            position.coords.longitude,
            parseFloat(enterprise.latitude.toString()),
            parseFloat(enterprise.longitude.toString())
          );
        }
        return 0; // Retourner 0 au lieu de null
      })
    );
  }
} 